import { Tabs, TabsList, TabsTrigger } from '@packages/shared/src/ui/Tabs/Tabs';
import { defineMessages, useIntl } from 'react-intl';

export type SubMenuTabsProps = {
  value: 'menu' | 'account';
  onChange?: (tab: 'menu' | 'account') => void;
};

const messages = defineMessages({
  menu: {
    id: 'slot.account.menu',
    defaultMessage: 'Menü',
  },
  account: {
    id: 'slot.account.label',
    defaultMessage: 'Mein Konto',
  },
});

export const SubMenuTabs = ({ value, onChange }: SubMenuTabsProps) => {
  const { formatMessage } = useIntl();

  return (
    <Tabs className="lg:hidden" defaultValue="menu" value={value}>
      <TabsList className="w-full">
        <TabsTrigger value="menu" className="flex-1" onClick={() => onChange?.('menu')}>
          {formatMessage(messages.menu)}
        </TabsTrigger>
        <TabsTrigger value="account" className="flex-1" onClick={() => onChange?.('account')}>
          {formatMessage(messages.account)}
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
};
